<template>
  <v-row class="menu pt-3">
    <v-col cols="12" sm="3" class="py-0">
      <v-select
        :label="$t('documents.draft')"
        v-model="draft"
        :items="drafts"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="3" class="py-0">
      <v-select
        clearable
        :label="$t('documents.type')"
        v-model="type"
        :items="types"
        item-text="name"
        item-value="id"
      ></v-select>
    </v-col>
    <v-col cols="7" sm="5" class="py-0">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$i18n.t('documents.search-label')"
        hide-details
        clearable
        class="pa-0 ma-0"
      ></v-text-field>
    </v-col>
    <v-col cols="5" sm="1" class="reset py-0">
      <v-btn v-on:click="reset" block>
        <v-icon>
          mdi-filter-remove-outline
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import debounce from "../../../assets/js/debounce";
export default {
  name: "SearchDocument",
  data: function() {
    let search = this.$route.query.search || "";
    let type = this.$route.query.type || "";
    let root = this.$route.query.root || false;
    let draft = this.$route.query.draft || "";
    let drafts = [
      { text: this.$t("documents.any"), value: "" },
      { text: this.$t("documents.without"), value: "without" },
      { text: this.$t("documents.only"), value: "only" }
    ];
    return {
      search,
      root,
      loading: false,
      type,
      draft,
      drafts
    };
  },
  computed: {
    types: {
      get() {
        return this.$store.getters["documentTypeStore/getList"];
      }
    }
  },
  methods: {
    queryForSearch() {
      let to = { ...this.$route };
      to.query = {
        ...to.query
      };
      let vm = this;
      function formParam(param) {
        if (vm[param]) {
          to.query[param] = vm[param];
        } else {
          delete to.query[param];
        }
      }
      formParam("search");
      formParam("type");
      formParam("draft");
      this.$router.push(to);
    },
    reset() {
      let to = { ...this.$route };
      this.search = "";
      this.type = "";
      to.query = {};
      this.$router.push(to);
    },
    startQueryForSearch: debounce(function() {
      this.queryForSearch();
    }, 500)
  },
  watch: {
    search() {
      this.startQueryForSearch();
    },
    type() {
      this.startQueryForSearch();
    },
    draft() {
      this.startQueryForSearch();
    }
  },
  mounted() {
    this.$store.dispatch("documentTypeStore/getList", { limit: -1 });
  }
};
</script>

<style lang="scss" scoped>
.menu {
  margin-top: 0;
  &::v-deep {
    .v-input__control .v-input__slot {
      margin-bottom: 0px;
    }
    .v-messages {
      display: none;
    }
  }
  .v-input {
    padding: 0;
    margin: 0;
    .v-input__slot {
      margin: 0;
    }
    .v-text-field__details {
      min-height: 0;
      height: 0;
    }
  }
}
</style>
